"use client"
import styled from "@emotion/styled"
import { useMemo } from "react"
import CustomSelect from "./CustomSelect"

const StyledSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

interface ManufacturerModelSectionProps {
  selectedManufacturer: string | null
  selectedModel: string | null
  handleManufacturerChange: (e: any) => void
  handleModelChange: (e: any) => void
  manufacturers: Array<{
    value: string
    label: string
    models: Array<{ value: string; label: string }>
  }>
}

function ManufacturerModelSection({
  selectedManufacturer,
  selectedModel,
  handleManufacturerChange,
  handleModelChange,
  manufacturers,
}: ManufacturerModelSectionProps) {
  // Get models for selected manufacturer
  const availableModels = useMemo(() => {
    if (!selectedManufacturer) return []
    const manufacturer = manufacturers.find(
      (m) => m.value === selectedManufacturer,
    )
    return manufacturer ? manufacturer.models : []
  }, [selectedManufacturer, manufacturers])
  return (
    <>
      {/* Manufacturer Select */}
      <StyledSection>
        <CustomSelect
          label="בחירת יצרן"
          placeholder="בחירת יצרן"
          options={manufacturers}
          onChange={handleManufacturerChange}
          value={selectedManufacturer}
        />
      </StyledSection>

      {/* Model Select */}
      <StyledSection>
        <CustomSelect
          label="בחירת דגם"
          placeholder="בחר דגם"
          options={availableModels}
          onChange={handleModelChange}
          value={selectedModel}
          disabled={!selectedManufacturer}
        />
      </StyledSection>
    </>
  )
}

export default ManufacturerModelSection
